import { createSlice } from '@reduxjs/toolkit';
import { TP_PRINT_DEFAULT_RADIO_OPTIONS, TP_PRINT_DEFAULT_SELECT_OPTIONS } from '../../../components/TalentProfileDownloadPreview/constants';

const downloadProfileSlice = createSlice({
  name: 'downloadProfile',
  initialState: {
    downloadSettings: {
      selectedOptions: TP_PRINT_DEFAULT_SELECT_OPTIONS,
      selectedValues: TP_PRINT_DEFAULT_SELECT_OPTIONS.map((i) => i.value),
      radioOptions: TP_PRINT_DEFAULT_RADIO_OPTIONS,
      approveSuccessionPlanningOptions: [{ label: 'All', value: 'All' }],
    },
    fetchedData: {},
  },
  reducers: {
    updateDownloadData: (state, action) => {
      const { sectionName, data } = action.payload;
      if (data) {
        state.fetchedData[sectionName] = data;
        return;
      }
      if (state.fetchedData[sectionName]) delete state.fetchedData[sectionName];
    },
    clearDownloadData: (state) => {
      state.fetchedData = {};
    },
    clearDownloadSetting: (state) => {
      state.downloadSettings.selectedOptions = TP_PRINT_DEFAULT_SELECT_OPTIONS;
      state.downloadSettings.radioOptions = TP_PRINT_DEFAULT_RADIO_OPTIONS;
      state.downloadSettings.selectedValues = TP_PRINT_DEFAULT_SELECT_OPTIONS.map((i) => i.value);
    },
    updateDownloadSettingSelection: (state, action) => {
      const selectedOptions = action.payload;
      state.downloadSettings.selectedOptions = selectedOptions;
      state.downloadSettings.selectedValues = selectedOptions.map((i) => i.value);
    },
    updateDownloadSettingRadio: (state, action) => {
      const radioOptions = action.payload;
      state.downloadSettings.radioOptions = radioOptions;
    },
    updateDownloadApproveSuccessionPlanningOptions: (state, action) => {
      state.downloadSettings.approveSuccessionPlanningOptions = action.payload;
    },
  },
});

export const { reducer: downloadProfilesReducer, actions } = downloadProfileSlice;
export const { updateDownloadData, clearDownloadData, clearDownloadSetting, updateDownloadSettingSelection, updateDownloadSettingRadio, updateDownloadApproveSuccessionPlanningOptions } = actions;
export default downloadProfilesReducer;
